// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".experience-table-wrapper .table tr td{padding:1.5rem 2rem}.experience-table-wrapper .table tr th{padding:1rem 2rem;border-top-color:#ebebeb;border-top-width:2px}.experience-table-wrapper .table tr:not(:last-child) td,.experience-table-wrapper .table tr th{border-bottom-color:#ebebeb;border-bottom-width:2px}.experience-table-wrapper .table tbody tr:hover{cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
